import React from 'react';
import connect from "react-redux/es/connect/connect";


const Loader = React.memo(({isFetching}) => {
    return (
        <div className={isFetching ? 'loading' : 'clear'}>
            <div className="loading-r">
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    )
});


const mapStateToProps = (state) => {
    return {
        isFetching: state.sellNowReducer.isFetching
    }
};

export default connect(mapStateToProps)(Loader);
